<template>
  <Popover
    placement="left-end"
    size="sm"
    variant="warning"
    :isDisabled="!isCompleteSomeData || isCompleteData"
  >
    <template slot="popover">
      取得中のデータがあります。<br />しばらくお待ちください。<br />※ダウンロードは可能ですが、取得中のデータは反映されません。
    </template>
    <div class="c-alertPos">
      <ButtonRadius
        priority="low-gray"
        :iconLeft="iconLeft"
        :class="{ 'is-loading': isProcessing }"
        :disabled="isDisabledButton"
        @click="getCsv"
      >
        CSV全件ダウンロード
      </ButtonRadius>
      <Alert v-if="error">{{ error }}</Alert>
    </div>
  </Popover>
</template>

<script>
import Alert from '@/components/Alert';
import ButtonRadius from '@/components/ButtonRadius';
import Popover from '@/components/Popover';
import apiProjects from '@/api/projects';
import utils from '@/utils';

export default {
  props: [
    'createdAt',
    'keyword',
    'project',
    'isCompleteData',
    'isCompleteSomeData'
  ],
  components: {
    Alert,
    ButtonRadius,
    Popover
  },
  data() {
    return {
      error: '',
      timeoutId: null,
      isProcessing: false
    };
  },
  computed: {
    iconLeft() {
      return this.isCompleteData ? 'download' : 'warningYellow';
    },
    isDisabledButton() {
      return !this.isCompleteSomeData || this.isProcessing;
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId);
  },
  methods: {
    getCsv() {
      if (this.isProcessing) {
        return;
      }
      this.isProcessing = true;
      this.error = '';

      const params = {
        keyword: this.keyword,
        dateJst: this.$options.filters.dateText(this.createdAt, 'YYYY-MM-DD'),
        location: 'tokyo',
        engine: 'google',
        device: 'desktop',
        fromRank: 1,
        toRank: 10,
        fields: 'intent'
      };

      apiProjects.contentPlans.tdh.download
        .get(params, this.auth.idToken, this.project.id)
        .then(response => {
          const date = utils.formatDate(new Date(), 'YYYY年MM月DD日');
          const fileName = `コンテンツ調査_${this.keyword}_${date}_${this.project.name}.csv`;
          utils.downloadFile(response.data, fileName);
          this.isProcessing = false;
        })
        .catch(error => {
          this.error = 'ダウンロードに失敗しました';
          this.timeoutId = setTimeout(() => {
            this.error = '';
          }, 2000);
          this.isProcessing = false;
        });
    }
  }
};
</script>
